
export default {
  head() {
    return {
      title: "Agence Google Ads | SEA à Antony dès 290€/mois - ALEO AGENCY",
      meta: [
        {
          hid: "description",
          name: "description",
          content:
            "ALEO, agence Google Ads à Antony certifiée Google Partner, accompagne les entreprises antoniennes pour développer leur visibilité en ligne et attirer davantage de clients.",
        },
        {
          hid: "og:title",
          property: "og:title",
          content: "Agence Google Ads à Antony dès 290€/mois - ALEO AGENCY",
        },
        {
          hid: "og:description",
          property: "og:description",
          content:
            "ALEO, agence Google Ads à Antony certifiée Google Partner, accompagne les entreprises antoniennes pour développer leur visibilité en ligne et attirer davantage de clients.",
        },
      ],
    };
  },
};
